import {
  Alert,
  LinearProgress,
  Stack,
} from '@mui/material';
import useCreateDataForDayTimeApi from 'Routes/Public/GetNewTurn/Hooks/useCreateDataForDayTimeApi';
import React from 'react';
import Days from './Days/Days';
import Times from './Times/Times';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import ScrollableContainer from './Days/ScrollableContainer';

const DaysTimes = ({ range }) => {
  const dayList = useCreateDataForDayTimeApi(range);
  const outOfAppointment = FindLangKey(
    'get-new-turn-appointments-full'
  );

  return (
    <React.Fragment>
      {range && dayList === 0 ? (
        <LinearProgress />
      ) : dayList ? (
        dayList?.length === 0 ? (
          <Alert
            severity="info"
            sx={{
              textAlign: 'center',
              justifyContent: 'center',
              fontSize: '1em',
              fontWeight: 'bold',
            }}
          >
            {outOfAppointment}
          </Alert>
        ) : (
          <Stack gap=".5em">
            <Days days={dayList} />
            <Times />
          </Stack>
        )
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default DaysTimes;
